<div
  class="transition-width relative flex min-h-screen flex-row duration-300"
  [ngClass]="{
    'w-0': !isSidebarOpen,
    'w-16': isSidebarOpen,
    'md:w-16': !isSidebarOpen,
    'md:w-56': isSidebarOpen
  }"
>
  <div class="flex flex-col overflow-hidden">
    <ul class="flexflex-col px-2 py-2">
      <li *ngFor="let sidebarRoute of sidebarRoutes">
        <a
          [routerLink]="sidebarRoute.path"
          class="flex h-12 transform flex-row items-center space-x-1 transition-transform duration-200 ease-in hover:translate-x-2 hover:text-gray-200"
        >
          <span class="inline-flex h-12 w-12 items-center justify-center text-lg">
            <fa-icon [icon]="sidebarRoute.icon"></fa-icon>
          </span>
          <span
            class="hidden text-sm font-medium"
            [ngClass]="{ 'md:hidden': !isSidebarOpen, 'md:flex': isSidebarOpen }"
            >{{ sidebarRoute.label }}</span
          >
        </a>
      </li>
    </ul>
  </div>
</div>
